/**
 * Barrel export para iconos
 * Permite importar iconos de forma más limpia:
 * import { Icon } from '@/components/ui/icons'
 */

export { default as Icon } from './Icon';
export type { IconName } from './Icon';
